import { useCallback } from 'react';

import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';

import { useBreakpoints } from '#client/pages/EducationStudio/hooks/useBreakpoints';

import { useLessonStorage } from '../../../hooks';
import { ExercisePage, MAX_CHARACTER_COUNT } from '../../Interactive/WorksheetActivity/exercisePage';
import {
  StyledImageContainer,
  StyledNextButton,
  StyledSharedAsset,
  StyledText,
  StyledTextArea,
  StyledUserInputText
} from '../../Interactive/WorksheetActivity/useStyles';
import { I_LOVE_TO } from './whatYouLove';
import { I_AM_GOOD_AT } from './whatYoureGoodAt';

const NEXT_BUTTON_TEXT = 'Next';
export const MY_PASSION_IS = 'myPassionIs';

export const YourPassion = ({ onNext }) => {
  const { lesson } = useParams();
  const { getStorageValue, setStorageValue, saveChanges } = useLessonStorage(lesson);
  const {
    sizes: { isMobile }
  } = useBreakpoints();

  const onNextHandler = useCallback(() => {
    saveChanges();
    onNext();
  }, [saveChanges, onNext]);

  const presentation = (
    <StyledImageContainer>
      <StyledSharedAsset
        src="/journey%20to%20success/01%20MVE%20Series/01%20PEAKS/mve_peaks_exercise9.svg"
        alt="ikigai-exercise"
        width={500}
      />
    </StyledImageContainer>
  );
  const summary = <StyledText size="lg">What you&apos;re good at and what you love.</StyledText>;

  return (
    <ExercisePage
      caption="Exercise"
      title="Your passion &#128165;"
      summary={summary}
      presentation={presentation}
      buttonText={NEXT_BUTTON_TEXT}
      isButtonDisabled={!getStorageValue(MY_PASSION_IS)}
      onNext={onNextHandler}
    >
      <StyledUserInputText
        size={isMobile ? 'lg' : 'xl'}
        color="wisdom40"
      >
        &#127942;
        {' '}
        <strong>I am good at</strong>
        {' '}
        {getStorageValue(I_AM_GOOD_AT)}
      </StyledUserInputText>
      <StyledText
        size={isMobile ? 'lg' : 'xl'}
        color="wisdom40"
      >
        &#10084;&#65039;
        {' '}
        <strong>I love to</strong>
        {' '}
        {getStorageValue(I_LOVE_TO)}
      </StyledText>
      <StyledTextArea
        placeholder="My passion is..."
        text={getStorageValue(MY_PASSION_IS)}
        onChangeHandler={(e) => setStorageValue(MY_PASSION_IS, e.target.value)}
        maxLength={MAX_CHARACTER_COUNT}
      />
      {!isMobile && (
      <StyledNextButton
        className="buttonRight"
        variant="contained"
        color="primary"
        size="large"
        disabled={!getStorageValue(MY_PASSION_IS)}
        onClick={() => onNextHandler()}
      >
        {NEXT_BUTTON_TEXT}
      </StyledNextButton>
      )}
    </ExercisePage>
  );
};

YourPassion.propTypes = {
  onNext: PropTypes.func
};

YourPassion.defaultProps = {
  onNext: () => {}
};

export default YourPassion;
